import { render, staticRenderFns } from "./ShopIndex.vue?vue&type=template&id=ac8dba40&scoped=true&"
import script from "./ShopIndex.vue?vue&type=script&lang=js&"
export * from "./ShopIndex.vue?vue&type=script&lang=js&"
import style0 from "./ShopIndex.vue?vue&type=style&index=0&id=ac8dba40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8dba40",
  null
  
)

export default component.exports